import { Injectable } from '@angular/core';
import { Baseproperties } from '../../utility/baseproperties';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { City } from '../../utility/modals';

@Injectable({
  providedIn: 'root'
})
export class UseraccesmappingService {
    baseproperties: Baseproperties = new Baseproperties(); 
    private baseURL = this.baseproperties.gatewayBaseURL+"/common/uam"
    scrollHeight: string = '22em'; 
    constructor(private httpClient: HttpClient,private route:Router) {}
      //Add New City
      savedata(payload): Observable<Object>{
        return this.httpClient.post(`${this.baseURL}/savedata`, payload);
      }
      getuser(): Observable<any>{
        return this.httpClient.get<any>(`${this.baseURL}/getuser`);
      }
      getproductlist(userid):Observable<any>{
        return this.httpClient.get<any>(`${this.baseURL}/getproductslist/${userid}`);
      }
      getUAM(userid,productid):Observable<any>{
      return this.httpClient.get<any>(`${this.baseURL}/getuseraccessmapping/${userid}/${productid}`);

      }
      
      getentitylist(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusercompany`,payload);

      }
         getverrticallist(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuservertical`,payload);

      }
       getusercasetypelist(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusercasetype`,payload);

      }
       getusersubvertical(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusersubvertical`,payload);

      }
       getuserdepartment(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserdepartment`,payload);

      }
       getuserspecialviewright(userid,productid):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserspecialright/${userid}/${productid}`,{});

      }
        getusersubdepartment(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusersubdepartment`,payload);

      }
       getuserlocation(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserlocation`,payload);

      }
      
        getusergroup(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusergroup`,payload);

      }
       getuserstate(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserstate`,payload);
      }
        getuserhub(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserhub`,payload);
      }
        getuserregion(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserregion`,payload);
      }
        getusercity(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusercity`,payload);
      }
        getusercountry(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusercountry`,payload);
      }
       getusercasetype(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusercasetype`,payload);
      }
       getuserlawcategory(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserlawcategory`,payload);
      }
       getusercontractcategory(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getusercontractcategory`,payload);
      }
       getuserregistrationcategory(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserregistrationcategory`,payload);
      }
       getuserdocumentcategory(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserdocumentcategory`,payload);
      }
          getuseriaprocess(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuseriaprocess`,payload);
      }
          getuserinspolicytype(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserinspolicytype`,payload);
      }
          getuserifcprocess(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserifcprocess`,payload);
      }
       getuserassignmentcategory(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserassignmentcategory`,payload);
      }
         getuserassessmentcategory(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/getuserassessmentcategory`,payload);
      }
      
      deleteUAM(payload):Observable<any>{
              return this.httpClient.post<any>(`${this.baseURL}/deletedata`,payload);
      }
}
